import axios from 'axios'
import { useHistory, useParams } from 'react-router'
import { authContext } from '../../context/AuthContext'
import Loading from '../helper/Loading';
import PageHeader from '../helper/PageHeader';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import moment from 'moment';
import DeleteDialog from '../helper/Dialogs';
import withStyles from '@mui/styles/withStyles';
import styles from "../styles";
import React, { useEffect, useState, useContext,  Fragment } from 'react'
import SortedTable from '../helper/SortedTable';
import { withTranslation } from 'react-i18next';


const AdminEmployerTraining = props => {

    const history = useHistory();
    const params = useParams();
    const context = useContext(authContext)
    const { t } = props;
    const token = sessionStorage.getItem('accessToken');

    const { classes } = props;

    const [loading, setLoading] = useState(true)


    const [infoContacts, setInfoContacts ] = useState({
            username: '',
            trainings: [],
            info: null,
            error: null,
            selectedTraining: undefined,
            contacts: [],
            //isDeleteDialogOpen: false,
            //itemToDelete: '',
            isDeleteTrainingDialogOpen: false,
            credit: 0,
            trainingToDelete: '',
            trainees: []
        
    });

    const [groupData, setGroupData] = useState({
            groupName: '',
            groupType: 'Employer',
            groupContact: undefined,
            groupID: params.id,
    });
    
    useEffect(()=>{
        setLoading(false);
        async function getGroupInformation(){
            setLoading(true)
            try {
                let res = await axios.get('/api/userGroup/' + params.id, {});
                let group = res.data;

                setGroupData(prevState =>{
                  return {...prevState,
                      groupName: group.usergroup.name,
                  }
                });
                let url = '/api/employerTraining/' + params.id ;
                res  = await axios.get(url, {});
                let result = res.data;

                setInfoContacts(prevState =>{
                    return {...prevState, 
                        credit: group.usergroup.credit,
                        trainees: result.trainees,
                        loading: false
                    }
                });

                setLoading(false)
            } catch (error) {
                setInfoContacts(prevState =>{
                return {...prevState, error: error.message }
                });
            }
        }
        if ( params.id !== undefined) 
            getGroupInformation();
        else 
            console.log("In else");
            
    }, [infoContacts.error, params.id]);

    

    const handleChange = event => {
        setInfoContacts(prevState =>{
            return {...prevState, [event.target.name]: event.target.value }
        });
    }

 
    let enhancedData = [];
    let filterTrainees = infoContacts.trainees.filter((arrayItem) => {
        return arrayItem.status !== 'Assigned';
    });

    enhancedData = filterTrainees.map((arrayItem) => {
        let item = JSON.parse(JSON.stringify(arrayItem));
        item.employeeName = item.employeeLastName + ", " + item.employeeFirstName;
        item.assignBy = item.last_name? item.last_name  + ', ' + item.first_name : '';
        item.enableLink = item.trainingId ? true : false;
        item.statusView =  t('trainingStatus.Status', { context: item.status });
        item.actionsDisabled = {
        delete: false
        }
        return item;
    });

    const onTrainingInfo = (id) => {
        let currentRow = infoContacts.trainees.find(e => e.id === id);
        axios.get('/api/userTraining/' + currentRow.trainingId).then((res) => {
            let userTraining = res.data.training;
   
            props.history.push('/dashboard/trainingHistory/details', { 
                trainingId: currentRow.trainingId, 
                username: currentRow.employeeUserID, 
                courseID: userTraining.courseId, 
                courseLabel: userTraining.courseLabel,
                courseType: userTraining.type,
                restricted: true // employer has restricted view on trainee's training detail
            });
        }).catch(error => {
           // this.setState({ error: error.message });
            setInfoContacts(prevState =>{
                return {...prevState, error: error.message }
            });
        });
    }

    const openDeleteTrainingDialog = (tag) => {
        console.log(tag)
        setInfoContacts(prevState =>{
            return {...prevState, trainingToDelete: tag }
        });
        handleDeleteTrainingDialogOpen();
    }

    const handleDeleteTrainingDialogOpen = () => {
        setInfoContacts(prevState =>{
            return {...prevState, isDeleteTrainingDialogOpen: true }
        });
    };

    const handleDeleteTrainingDialogClose = () => {

        setInfoContacts(prevState =>{
            return {...prevState, isDeleteTrainingDialogOpen: false }
        });

    };

    const headCells = [
        { id: 'Action', label: 'Action', centered: false},
        { id: 'lastModified', label: 'Assign Date', centered: false, sortable: true },
        { id: 'assignBy', label: 'Assign By', centered: false, sortable: true },
        { id: 'employeeName', label: 'Employee Name', centered: false,sortable: true},
        { id: 'employeeDOB', label: 'Employee DOB', centered: false,sortable: true },
        { id: 'supervisorLastName', label: 'Supervisor Last Name', centered: false ,sortable: true},
        { id: 'employeeUserID', label: 'Employee Username', centered: false,sortable: true },
        { id: 'statusView', label: 'Status', centered: true, sortable: true },
        { id: 'certID', label: 'Certificate ID', centered: true, sortable: true}
    ];

    const bodyCells = [
        { id: 'lastModified', centered: false},
        { id: 'assignBy', centered: false},
        { id: 'employeeName', centered: false },
        { id: 'employeeDOB',  centered: false },
        { id: 'supervisorLastName', centered: false },
        { id: 'employeeUserID', centered: false, hyperlink: onTrainingInfo },
        { id: 'statusView', centered: true },
        { id: 'certID', centered: true }
    ];

   

    const actionButtons = [
        { icon: "delete", action: openDeleteTrainingDialog, delete: true },
    //    { icon: "training", label: "Employee Result", action: onTrainingInfo, view: "showResult"},
    ];

    const defaultSortKey = 'lastModified';

    const onSearch = async (event) => {
        try {
            let result = await axios.get('/api/userTraining/all/' + infoContacts.username);
            result = result.data;
            let trainings = [];
            let msg = null;
            console.log(result.trainings)
            if (result.trainings.length > 0) {
                result.trainings.map((u) =>
                    trainings.push({ label:  u.type + ' - ' + moment(u.registerDate).format('YYYY-MM-DD HH:mm:ss'), value: u.id })
                );
            } else {
                msg = "No user training found"
            }
            setInfoContacts(prevState =>{
                return {...prevState, 
                    info: msg, 
                    trainings: trainings,
                    selectedTraining: undefined
                }
            });
        } catch(error) {
            console.log("error:" + error);
        }
    }

    const onSelectTraining = (name, value) => {
        let selected = value;

        if (selected === null) {
            setInfoContacts(prevState =>{
                return {...prevState, selectedTraining: '' }
            });
            
            return;
        }

        setInfoContacts(prevState =>{
            return {...prevState, selectedTraining: JSON.parse(JSON.stringify(selected)) }
        });

    }

    const onAddTraining = async (event) => {
        event.preventDefault();

        console.log("onAddTraining: ");
     
        let data = {
            employerID: groupData.groupID,
            employerName: groupData.groupName,
            firstName: infoContacts.firstName,
            last_name: infoContacts.lastName,
            employeeUsername: infoContacts.username,
            trainingID: infoContacts.selectedTraining.value,
            lastModifiedBy: context.user.username
        }

        try {

            let res = await axios('/api/employerTraining/add', {
                method: 'POST',
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            });
            if (res) {
                let url = '/api/employerTraining/' + groupData.groupID;
                let result = await axios(url, {
                    method: 'GET'
                });
                setInfoContacts(prevState =>{
                    return {...prevState, 
                        trainees: result.data.trainees
                } });
            }
        } catch (err) {
            // handled by App.js
        }  
    }

    const onRemoveTraining = async (event) => {
        event.preventDefault();

        console.log("onRemoveTraining: ");
        handleDeleteTrainingDialogClose();

        let trainingID = infoContacts.trainingToDelete;
        let data = {
            employerID: groupData.groupID,
            employerName: groupData.groupName,
            employeeUsername: infoContacts.username,
            employerTrainingID: trainingID,
            lastModifiedBy: context.user.username
        }
        console.log(data)
        try {
            let res = await axios('/api/employerTraining/remove', {
                method: 'POST',
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            });
            if (res) {
                let url = '/api/employerTraining/' + groupData.groupID;
                let result = await axios(url, {
                    method: 'GET'
                });
                setInfoContacts(prevState =>{
                    return {...prevState, 
                        trainees: result.data.trainees
                } });
            }
        } catch (err) {
            // handled by App.js
        }  
    }

    return (
        <>
        {
            loading 
            ? 
            <Loading />
            : 
            <Fragment>
                <PageHeader
                    title={"Correct Previous Employee Training for " + groupData.groupName}
                    cancel={history.goBack}
                />
                <Alert severity="info">Add or remove previous employee training for an employer without adding or removing credit.</Alert>
                <ValidatorForm
                    noValidate
                    onSubmit={onAddTraining}
                >

                <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <TextValidator
                        label="Enter username"
                        name='username'
                        value={infoContacts.username}
                        className={[classes.textField].join(' ')}
                        onChange={handleChange}
                        validators={['required']}
                        errorMessages={['Username is required', 'Please enter a valid username']}
                        fullWidth
                        required
                    />
                </Grid>
                <Grid item xs={12}  md={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    className={[].join(' ')} 
                    onClick={ onSearch}
                >
                    Search
                    </Button>
                </Grid>
                <Grid item xs={12}  md={4}>
                    <Autocomplete
                        id="user"
                        options={infoContacts.trainings}
                        getOptionLabel={(option) => option.label}
                        // getOptionSelected={(option, val) => val === "" || option.value === val}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        value={infoContacts.selectedTraining || { label: "" }}
                        onChange={onSelectTraining}
                        className={[classes.autoComplete].join(' ')}
                        renderInput={(params) => <TextValidator {...params}
                            label="Select training to add"
                            value={infoContacts.trainings.length === 0 ? "-" : infoContacts.selectedTraining}
                            validators={['required']}
                            errorMessages={['Please select a user training']}
                            required
                        />}
                        disabled={infoContacts.trainings.length === 0}
                    />
                </Grid>
                <Grid item xs={12}  md={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    className={[].join(' ')} 
                    disabled={ infoContacts.selectedTraining === undefined}
                    type="submit" 
                    >
                    Add User Training
                    </Button>
                </Grid>
               
                </Grid>
                    <br /><br />
                    <SortedTable
                                data={enhancedData}
                                headCells={headCells}
                                bodyCells={bodyCells}
                                defaultSortKey={defaultSortKey}
                                defaultOrder={"desc"}
                                cellKey={"id"}
                                editDelete={false}
                                actionButtons={actionButtons}
                                actions={true}
                            />  

                    <DeleteDialog
                        open={ infoContacts.isDeleteTrainingDialogOpen}
                        onClose={handleDeleteTrainingDialogClose}
                        onDelete={onRemoveTraining}
                    />
                </ValidatorForm>
            </Fragment>
        }
        </>

    )
}

export default withStyles(styles, { withTheme: true })(withTranslation()(AdminEmployerTraining));
